import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { isLink } from '@numa-group/ui.button-or-link';

import Spinner from './spinner';
import { ButtonWrapper, ChildContainer, LinkButtonWrapper, LoadingIndicator } from './styles';
import { ButtonProps } from './types';

const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>((props, ref) => {
  const content = (
    <>
      <ChildContainer $isVisible={!props.isLoading}>{props.children}</ChildContainer>

      {props.isLoading && (
        <LoadingIndicator aria-busy="true" aria-live="polite" role="status">
          <Spinner />
        </LoadingIndicator>
      )}
    </>
  );

  if (isLink(props)) {
    const { variant = 'primary', isLoading = false, children: _children, type: _type, ...restProps } = props;
    const { isExternal, ...linkProps } = restProps;

    const linkButtonProps = {
      ...linkProps,
      ...(isExternal && {
        target: '_blank',
        rel: 'noreferrer noopener',
      }),
    };

    return (
      <LinkButtonWrapper
        ref={ref as React.ForwardedRef<HTMLAnchorElement>}
        {...linkButtonProps}
        $variant={variant}
        $isLoading={isLoading}
      >
        {content}
      </LinkButtonWrapper>
    );
  }

  const { variant = 'primary', isLoading = false, children: _children, ...restProps } = props;

  return (
    <ButtonWrapper
      ref={ref as React.ForwardedRef<HTMLButtonElement>}
      $variant={variant}
      $isLoading={isLoading}
      {...restProps}
    >
      {content}
    </ButtonWrapper>
  );
});
Button.displayName = 'Button';
export default styled(Button)``;
